import { Plugin } from '../../types';
import { buildSelector } from '../../web/selector';
export const keyboard: Plugin = {
  name: 'keyboard',
  page: (emit) => {
    window.document.addEventListener('keypress', (e) => {
      if( e.ctrlKey && e.shiftKey){
        return;
      }
      const now = Date.now()
      const element = e.composedPath()[0] as HTMLElement
      let selector;
      try{
        selector = buildSelector({
          attribute: "",
          isClick: false,
          target: element,
        })
      }catch(err){
        console.log(err)
      }
      emit('keyboard',{
        type: 'keypress',
        key: e.key,
        time: now,
        selector 
      });
    });
    window.document.addEventListener('keyup', (e)=>{
      const now = Date.now()
      if ([9,8,20].includes(e.keyCode) ) { // special handling of tab, backspace, Capslock
        emit('keyboard',{
          type: 'keypress',
          key: e.key,
          time: now
        })
      }
    });
    window.document.addEventListener('paste', (e)=>{
      const text = e.clipboardData.getData('text')
      if(text){
        const now = Date.now()
        const element = e.composedPath()[0] as HTMLElement
        let selector;
        try{
          selector = buildSelector({
            attribute: "",
            isClick: false,
            target: element,
          })
        }catch(err){}
        emit('keyboard',{
          type: 'type',
          value: text,
          time: now,
          selector 
        });      
      }
    })
    return () =>{ 
      // window.document.removeEventListener(presslistener)
    }
  },
  reduce(previousEvents, event){
    const previousEvent = previousEvents[previousEvents.length-1]
    if(!previousEvent){
      return previousEvents.concat([event])
    }
    if(previousEvent.type === 'keypress' && previousEvent.selector && previousEvent.key.length === 1
      && event.type === 'keypress' && event.selector === previousEvent.selector && event.key.length === 1
    ){
      return previousEvents.slice(0,-1).concat([{...event,type: 'type',
      value: `${previousEvent.key}${event.key}`,
      }])
    }
    if(previousEvent.type === 'type' && event.type === 'keypress' 
      && event.selector === previousEvent.selector && event.key.length === 1
    ){
      return previousEvents.slice(0,-1).concat([{...event,type: 'type',
      value: `${previousEvent.value}${event.key}`}])
    }
    if(event.type === 'keypress' && event.selector && event.key.length === 1){
      return previousEvents.concat([{...event,type: 'type',
      value: `${event.key}`,
      }])
      
    }
    return previousEvents.concat([event])
  },
  test: {
    matchers: {
      toType: async (page, selector, text) => {
        try {
          await page.type(selector, text);
          return { pass: true, message: () => "Page types " + text };
        } catch (err) {
          return {
            pass: false,
            message: () => "Page did not type " + text,
          };
        }
      },
      toPress: async (page, key) => {
        try {
          await page.keyboard.press(key)
          return { pass: true, message: () => "Page presses " + key };
        } catch (err) {
          return {
            pass: false,
            message: () => "Page did not press " + key,
          };
        }
      },
    }
  },
  generate(event) {
    if(event.type === 'keypress'){
      return `
      it("presses \`${event.key}\`", async () => {
        await expect(page).toPress('${event.key}')
      })
      `
    }else if(event.type === 'type'){
      return `
      it("types \`${event.value}\` on \`${event.selector.replace(/"/gi, '\\"')}\`", async () => {
        await expect(page).toType('${event.selector}', '${event.value}')
      })
      `
    }
    return ''
  },
};

export default keyboard